import { createSlice } from '@reduxjs/toolkit';
export const THEME_KEY = 'boushar.theme.settings';
const MODES = ['light', 'dark', 'system'];
export const loadThemeSettings = () => {
    try {
        const stored = localStorage.getItem(THEME_KEY);
        if (stored != undefined) {
            const parsed = JSON.parse(stored);
            if (MODES.includes(parsed === null || parsed === void 0 ? void 0 : parsed.mode)) {
                return parsed;
            }
        }
    }
    catch (error) {
        console.error('Failed to read theme settings from localStorage:', error);
    }
    return { mode: 'system' }; // Default: follow the OS
};
const saveThemeSettings = (state) => {
    try {
        localStorage.setItem(THEME_KEY, JSON.stringify(state));
    }
    catch (error) {
        console.error('Failed to save theme settings to localStorage:', error);
    }
};
const themeSlice = createSlice({
    name: 'theme',
    initialState: loadThemeSettings,
    reducers: {
        setThemeMode: (state, action) => {
            state.mode = action.payload;
            saveThemeSettings(state);
        }
    }
});
export const { setThemeMode } = themeSlice.actions;
export default themeSlice;
